const Type = {
    GLOBAL: 0,
    ON_OUTPUTS: 1,
    ON_CATEGORIES: 2,
}

class MissionService {

    type(mission) {
        let outExists = mission.properties["ai_mission:output_focus"];
        let catExists = mission.properties["ai_mission:categories_focus"] && mission.properties["ai_mission:categories_focus"].length > 0; // it's an array

        if (!outExists && !catExists) {
            return Type.GLOBAL;
        }

        if (outExists && !catExists) {
            return Type.ON_OUTPUTS;
        }

        if (catExists && outExists) {
            return Type.ON_CATEGORIES;
        }

        return -1;
    }

    values(mission) {
        let type = this.type(mission);
        switch (type) {
            case Type.ON_OUTPUTS: {
                let focus = mission.properties["ai_mission:output_focus"];
                return !focus ? [] : focus;
            }
            case Type.GLOBAL:
                return [];
            case Type.ON_CATEGORIES: {
                let focus = mission.properties["ai_mission:categories_focus"];
                return !focus ? [] : focus;
            }
            default:
                return [];
        }
    }

    dataPoints(mission) {
        if(mission.contextParameters.mission && mission.contextParameters.mission.evaluation_result) {
            let enrichRes = mission.contextParameters.mission.evaluation_result;
            let results = Object.values(enrichRes);
            if (results.length === 1) {
                results.push(results[0]);
            }
            return results.map(val => (val * 100).toFixed(2), []);
        }
        else {
            return [];
        }
    }

    outcomeDataPoints(mission) {
        let enrichRes = mission.contextParameters.mission_metrics && mission.contextParameters.mission_metrics.evaluation_autofill_performance;
        if (!enrichRes) {
            return;
        }
        for (const key of Object.keys(enrichRes)) {
            const version = enrichRes[key];
            if (!version) {
                return;
            }
        }
    }

    goalLine(mission) {
        if(mission.contextParameters.mission && mission.contextParameters.mission.evaluation_result) {
            let results = mission.contextParameters.mission.evaluation_result;
            const dots = Object.keys(results).map(() => {
                return mission.properties["ai_mission:goal"];
            }, []);

            if (dots.length === 1) {
                dots.push(dots[0]);
            }

            return dots;
        }
        else {
            return [];
        }
    }

    evaluationLabels(mission) {
        if(mission.contextParameters.mission && mission.contextParameters.mission.evaluation_result) {
            let enrichRes = mission.contextParameters.mission.evaluation_result;
            return Object.keys(enrichRes);
        }
        else {
            return [];
        }
    }

    _average(arr) {
        return arr.reduce((a, b) => a + b, 0) / arr.length
    }
}


export const missionService = new MissionService();